// src/shared/components/GpsLoadingOverlay/index.js
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import './styles.css';

const GpsLoadingOverlay = ({ isVisible = false }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="gps-loading-overlay">
      <div className="gps-loading-backdrop" />
      <Card className="gps-loading-card">
        <Card.Body>
          <div className="gps-loading-content">
            <div className="gps-loading-spinner">
              <i className="bi bi-geo-alt"></i>
            </div>
            <h5 className="gps-loading-title">Analyzing GPS Data</h5>
            <p className="gps-loading-message">
              Calculating distance, elevation, duration, and activity type...
            </p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

GpsLoadingOverlay.propTypes = {
  isVisible: PropTypes.bool,
};

GpsLoadingOverlay.defaultProps = {
  isVisible: false,
};

export default GpsLoadingOverlay;
